export var window = (typeof globalThis !== 'undefined' ? globalThis : self);
